import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ubs-view-combo-container',
  templateUrl: './view-combo-container.component.html',
  styleUrls: ['./view-combo-container.component.scss']
})
export class ViewComboContainerComponent implements OnInit {
  @Input() value:any;
  @Input() componentConfig:any;
  @Input() options:any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
